import moment from "moment";

import { RadioButtonv2 } from "@/Common/Components/Inputs/RadioButtonv2";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";

enum TaskGroupType {
    Individaul,
    Group
}

class TaskViewModel {
    public groupTaskType: TaskGroupType;
    public dueDate: Date;
    public statusLookupId: string;
    public attachedLab: string;

    constructor(isGroup: boolean, dueDate: Date, statusLookupId: string, attachedLab: string) {
        this.groupTaskType = isGroup ? TaskGroupType.Group : TaskGroupType.Individaul;
        this.dueDate = dueDate;
        this.statusLookupId = statusLookupId;
        this.attachedLab = attachedLab;
    }
}

interface ITaskViewNewProps {
    model: TaskViewModel;

    /**
     * The task status lookup ID for the current user, if applicable.
     */
    currentUserStatusId: string | null;

    onGroupTaskSelectionChange: (isGroup: boolean) => void;
    onTaskStatusSelectionChange: (statusId: string) => void;
}

class TaskViewComponent extends React.Component<ITaskViewNewProps, any> {
    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public componentDidUpdate(): void { // this is required for patient panel
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        const model = this.props.model;
        if (!model)
            return null;

        const taskStatusLookups = Immutable.List(cacheStore.FindLookupsByTypeCode("TaskStatus"));
        const allGroupTypes = this.getAllGroupType();

        return (
            <div>
                <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                        <label className="form-label">{cacheStore.GetString("DueDateLabel")}</label>
                    </div>
                    <div className="col-lg-9 col-md-9 col-sm-9 form-field-answer">
                        <div className="tbc" style={{ paddingRight: "15px" }}>
                            <span>{model.dueDate ? moment(model.dueDate).format("YYYY-MM-DD HH:mm:ss") : ""}</span>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-2 col-md-3 col-sm-12  text-right">
                        <label className="form-label">{cacheStore.GetString("TaskTypeLabel")}</label>
                    </div>
                    <div className="col-lg-6 col-md-9 col-sm-12 ">
                        <RadioButtonv2
                            onChangeCallback={selected => this.handleGroupTypeSelectionChange(selected)}
                            htmlName="GroupTask"
                            items={allGroupTypes}
                            selectedItem={model.groupTaskType}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                        <label className="form-label">{cacheStore.GetString("IndividualStatusLabel")}</label>
                    </div>

                    <div className="col-lg-6 col-md-9 col-sm-12 ">
                        <select onChange={e => this.handleStatusSelectionChange(e)} className="form-control myle-control" data-cy="taskViewComponent-individualStatus" value={this.props.currentUserStatusId || model.statusLookupId}>
                            {taskStatusLookups.map(p =>
                                <option key={p.LookupID} value={p.LookupID}>{cacheStore.GetLocalizedValueByLookupId(p.LookupID)}</option>
                            )}
                        </select>
                    </div>
                </div>
            </div>
        );
    }

    private handleGroupTypeSelectionChange(selected: KeyValuePair<TaskGroupType, string>): void {
        const selectedType = Number(selected.Key) as TaskGroupType;
        if (!isNaN(selectedType) && this.props.onGroupTaskSelectionChange) {
            const isGroup = selectedType === TaskGroupType.Group;
            this.props.onGroupTaskSelectionChange(isGroup);
        }
    }

    private handleStatusSelectionChange(e: React.ChangeEvent<HTMLSelectElement>): void {
        const value: string = e.target.value;
        if (value && this.props.onTaskStatusSelectionChange) {
            this.props.onTaskStatusSelectionChange(value);
        }
    }

    private getAllGroupType(): Immutable.List<KeyValuePair<TaskGroupType, string>> {
        return [
            new KeyValuePair(TaskGroupType.Group, cacheStore.GetString("GroupTaskLabel")),
            new KeyValuePair(TaskGroupType.Individaul, cacheStore.GetString("IndividualTaskLabel"))
        ].toImmutable();
    }
}

export { TaskViewComponent, TaskViewModel };
